import React from 'react'
import { Col, Row } from 'react-bootstrap';
import img from '../img/custom mail.jpeg'
import Image from 'react-bootstrap/Image';
import './AirExportLogisticsSoftware.css';
import './About.css';
import Sidebar from './Sidebar';

function CustomisedBusinessEmailServices() {
  return (
    <>
    <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div className="container my-4">
      <Row>
        <Col xs={12} sm={9}>
          <h1 className='mt-5 pt-4 text-danger'>Customised Business Email Services</h1>
          {/* <Image className='my-2 fade-in' src={img} height={500} fluid /> */}
          <p class="fs-6 text-justify">In today’s fast-paced business world, your email is more than just a communication tool — it’s the face of your brand. At Catus Technologies, we provide Customised Business Email Services that give your organisation a professional, secure, and scalable communication platform tailored exactly to your needs.</p>
              <ul>
                <h4 style={{ textIndent: "-1.5rem" }}>Why Choose Customised Business Emails?</h4>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Professional Brand Identity – Use your own domain name for emails (e.g., you@yourcompany.com) to build trust and brand recognition.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Tailored Features – Get the storage, tools, and configurations you need without paying for unnecessary extras.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Enhanced Security – Built-in spam protection, advanced encryption, and secure servers keep your data safe.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Collaboration Ready – Shared calendars, contacts, and file storage streamline teamwork.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Scalable Solutions – Whether you’re a startup or an enterprise, our email solutions grow with your business.</li>
              </ul>

              <ul>
                <h4 style={{ textIndent: "-1.5rem" }}>Our Offerings</h4>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Domain-Based Email Hosting – Personalised emails for your entire team.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Custom Storage & Access Controls – Allocate resources and permissions as per role or department.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Mobile & Desktop Compatibility – Access your email anywhere, anytime.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Migration & Setup Support – Smooth transfer from your existing provider without data loss.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>24/7 Technical Assistance – Always-on support to keep your communication running seamlessly.</li>
              </ul>

              <ul>
                <h4 style={{ textIndent: "-1.5rem" }}>Benefits to Your Business</h4>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Build trust with clients and partners.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Maintain control over your communication channels.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Maintain control over your communication channels.</li>
                <li class="fs-6" style={{ textIndent: "-1.5rem" }}>Reduce downtime with reliable hosting.</li>
              </ul>
          <p class="fs-6 text-justify">Catus Technologies combines cutting-edge infrastructure with personalised service to deliver email solutions that don’t just work — they work for you.</p>
          <p class="fs-6 text-justify">Start building your professional communication system today with Catus Technologies’ Customised Business Email Services.</p>
        </Col>

        <Col xs={12} sm={3}>
        <Sidebar/>
        </Col>
      </Row>
    </div>
    </>
  )
}

export default CustomisedBusinessEmailServices